module.exports = __webpack_public_path__ + "images/expand5bf66f730cbe9d946fbb9d5516ed858f.svg";